import useSWR from 'swr';
import { PbService } from '../service';
import { Content } from '../types';
import { WebsiteMenu, Device } from '@tempi/core-renderer';
import { useTenantConfig } from 'hooks';
import { useRouter } from 'next/router';
import { userSelectedConstants } from 'constants/index';
import { getUserSelectedInfo } from 'helpers/env';

type UsePbPageReturn = {
  content?: Content;
  menu?: WebsiteMenu[];
  websiteId?: number;
};
type UsePbPage = (params: {
  page: string;
  device: Device;
  defaultValue?: UsePbPageReturn;
}) => UsePbPageReturn & {
  loading?: boolean;
  error?: string;
};

export const usePbPage: UsePbPage = ({ page, device, defaultValue }) => {
  const {
    tempiWebsiteDomain,
    epicEcom480,
    showPbPagesFromWebsiteEditor,
    isMobile,
  } = useTenantConfig();
  const router = useRouter();
  const terminalIdFromCookies = getUserSelectedInfo(
    userSelectedConstants.TERMINAL_ID,
    isMobile,
    true,
  );
  const terminalId = terminalIdFromCookies
    ? Number(terminalIdFromCookies)
    : undefined;
  const enableOmni1524 =
    // config must be true
    showPbPagesFromWebsiteEditor &&
    // path should be buildpc page
    router.asPath.includes('buildpc') &&
    // path is not a collection or landing page
    // e.g: /buildpc --> enable; /p/buildpc --> disable
    !new RegExp(/\/([c|p]+)\//).test(router.asPath);

  const { data, error, isValidating } = useSWR(
    [page, device, terminalIdFromCookies],
    async (page, device) => {
      const builder = new PbService(
        epicEcom480 || enableOmni1524
          ? tempiWebsiteDomain || ''
          : window?.location?.hostname || '',
        window?.location?.hostname,
        epicEcom480 || enableOmni1524 || false,
      );
      const { content, menu, websiteId }: UsePbPageReturn =
        await builder.getContentPage(page, device, terminalId);

      return { content, menu, websiteId };
    },
    {
      fallbackData: defaultValue,
      revalidateOnFocus: false,
    },
  );

  return {
    ...data,
    error,
    loading: isValidating,
  };
};
